import { Component, Input, OnInit } from '@angular/core';
import { AttributeValue, EditedAttributeValues } from '../../../../../models/section-definition.model';
import { AttributeValidationError } from '../attribute-number-edit-row/attribute-number-edit-row.component';

export function getTextValidationError(
  attr: AttributeValue,
  value: string | null,
): AttributeValidationError | null {
  if (!value) {
    return attr.isRequired ? { key: 'COMMON.ATTRIBUTE_VALIDATION.REQUIRED' } : null;
  }
  if (attr.regularExpression && !new RegExp(attr.regularExpression).test(value)) {
    return { key: 'COMMON.ATTRIBUTE_VALIDATION.INVALID_FORMAT' };
  }
  return null;
}

@Component({
  selector: 'lib-attribute-text-edit-row',
  standalone: false,
  templateUrl: './attribute-text-edit-row.component.html',
  styleUrls: ['./attribute-text-edit-row.component.scss'],
})
export class AttributeTextEditRowComponent implements OnInit {
  @Input() attributeValue!: AttributeValue;
  @Input() editedValues: EditedAttributeValues = {};
  value: string = '';
  error: AttributeValidationError | null = null;

  ngOnInit(): void {
    const id = this.attributeValue.attributeDefinitionId;
    this.value = ((id in this.editedValues ? this.editedValues[id] : this.attributeValue.stringValue) as string | null) ?? '';
    this.validate(this.value || null);
  }

  onValueChange(value: string) {
    const newValue = value || null;
    this.editedValues[this.attributeValue.attributeDefinitionId] = newValue;
    this.validate(newValue);
  }

  private validate(value: string | null) {
    this.error = value !== null && value === (this.attributeValue.stringValue || null)
      ? null
      : getTextValidationError(this.attributeValue, value);
  }
}
